export default import.meta.ROLLDOWN_FILE_URL_XHua6UJdp9t4k2f011Vhog